import {
    Alert,
    Box,
    Button,
    Card,
    CircularProgress,
    Grid,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useState } from "react";
import { POST } from "../../../Utilities/BaseService";

const CompleteReading = () => {
    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down("md"));

    const [meterNo, setMeterNo] = useState("");
    const [startMonthStr, setStartMonthStr] = useState("");
    const [endMonthStr, setEndMonthStr] = useState("");

    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState<any>({
        severity: "",
        message: "",
        show: false,
    });

    const handleSubmit = async (ev: any) => {
        ev.preventDefault();
        setLoading(true);
        setFeedback({ show: false, message: "", severity: "" });

        if (!meterNo || !startMonthStr || !endMonthStr) {
            setFeedback({
                message:
                    "Please fill in all fields (Meter No, Start Month, End Month)",
                severity: "error",
                show: true,
            });
            setLoading(false);
            return;
        }

        const [startYear, startMonth] = startMonthStr.split("-").map(Number);
        const [endYear, endMonth] = endMonthStr.split("-").map(Number);

        try {
            const res = (await POST("/reading/change-to-completed", {
                meterNo,
                startMonth,
                startYear,
                endMonth,
                endYear,
            })) as any;

            setFeedback({
                message:
                    res.data.message ||
                    `Successfully  ${res.data.count} readings`,
                severity: "success",
                show: true,
            });
            setLoading(false);
        } catch (error: any) {
            console.log(error, "error");
            setFeedback({
                message:
                    error?.response?.data?.message ||
                    "Failed to complete reading",
                severity: "error",
                show: true,
            });
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: mdDown ? "auto" : `calc(100vh - 96px)`,
            }}
        >
            <Card
                elevation={0}
                sx={{ bgcolor: theme.palette.common.white, p: 2, mb: "1rem" }}
            >
                <Typography
                    variant="h5"
                    sx={{ p: "4px", mb: "4px" }}
                    color="GrayText"
                >
                    Complete Reading Status
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Meter No."
                            fullWidth
                            size="small"
                            value={meterNo}
                            onChange={(e) => setMeterNo(e.target.value)}
                            required
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            size="small"
                            label="Start Month"
                            type="month"
                            fullWidth
                            value={startMonthStr}
                            onChange={(e) => setStartMonthStr(e.target.value)}
                            required
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <TextField
                            size="small"
                            label="End Month"
                            type="month"
                            fullWidth
                            value={endMonthStr}
                            onChange={(e) => setEndMonthStr(e.target.value)}
                            required
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onClick={handleSubmit}
                            disabled={
                                loading ||
                                !meterNo ||
                                !startMonthStr ||
                                !endMonthStr
                            }
                            endIcon={
                                loading ? (
                                    <CircularProgress
                                        size="1rem"
                                        color="inherit"
                                    />
                                ) : null
                            }
                        >
                            Complete Reading
                        </Button>
                    </Grid>

                    {feedback.show && (
                        <Grid item xs={12}>
                            <Alert severity={feedback.severity}>
                                {feedback.message}
                            </Alert>
                        </Grid>
                    )}
                </Grid>
            </Card>
        </Box>
    );
};

export default CompleteReading;
